export const stats = {
  general: {
    block: {
      main: 'Звонки',
      acd: 'ACD',
      asr: 'ASR'
    },

    filter: {
      group_by: {
        title: 'Группировать по',
        values: {
          day: 'День',
          month: 'Месяц',
          country: 'Страна'
        }
      },

      type: {
        title: 'Тип',
        values: {
          outgoing: 'Исходящие',
          incoming: 'Входящие'
        }
      },

      source: {
        title: 'Источник данных'
      },

      destination: {
        title: 'Направление'
      }
    },

    field: {
      group: 'Группировка',
      total: 'Итого',
      asr: 'ASR',
      acd: 'ACD',
      duration: 'Продолжительность',
      cost: 'Стоимость'
    }
  },

  detailed: {
    field: {
      country: 'Страна',
      source: 'Источник данных (A-номер)',
      destination: 'Направление (B-номер)',
      duration: 'Продолжительность',
      cost: 'Стоимость',
      date: 'Дата',
      call_type: 'Тип звонка',
      audio: 'Аудио'
    }
  }
};
